import debounce from 'lodash.debounce';
import { useEffect, useState } from 'react';

export function useSectionRefs(tableOfContents) {
  const [sectionRefs, setSectionRefs] = useState([]);
  const [visibleSection, setVisibleSection] = useState(null);

  // Build section refs
  useEffect(() => {
    if (!tableOfContents || typeof window === 'undefined' || !document) return;

    const sectionNodes = document.querySelectorAll('[data-section-num]');
    const articleEl = document.getElementById('article');
    const header = document.getElementById('hero-section');

    if (!header || !articleEl || sectionNodes.length === 0) return;

    const headerHeight = header.getBoundingClientRect().height;

    const sections = Array.from(sectionNodes).map((section, i, arr) => {
      const offsetTop = section.offsetTop + headerHeight;
      const offsetBottom = arr[i + 1]
        ? arr[i + 1].offsetTop + headerHeight
        : articleEl.offsetTop + articleEl.getBoundingClientRect().height;

      const item = tableOfContents.find((item) => item.sectionId === section.id);
      return {
        id: section.id,
        title: item?.title,
        offsetTop,
        offsetBottom,
        ref: section,
      };
    });

    setSectionRefs(sections);
  }, [tableOfContents]);

  // Handle scroll and update visible section
  useEffect(() => {
    if (sectionRefs.length === 0) return;

    const handleScroll = debounce(() => {
      const scrollY = window.scrollY + 30;
      const found = sectionRefs.find((sec) => scrollY > sec.offsetTop && scrollY < sec.offsetBottom);

      if (found?.id !== visibleSection) {
        setVisibleSection(found?.id);
      } else if (!found && visibleSection) {
        setVisibleSection(null);
      }
    }, 100); // 100ms debounce

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel?.(); // cancel debounce on teardown
    };
  }, [sectionRefs, visibleSection]);

  return { sectionRefs, visibleSection };
}
